import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler,HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { throwError, Observable, BehaviorSubject, of } from "rxjs";
import { catchError, filter, take, switchMap } from "rxjs/operators";
import { environment } from 'src/environments/environment';
 import { getUserSession } from "../utils/util";
import { Router } from "@angular/router";
@Injectable()

export class AuthInterceptor implements HttpInterceptor {
  private AUTH_HEADER = "Authorization";
  private token = "secrettoken";
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private router: Router) { }
 
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    var session = localStorage.getItem('app_user_session')
    const useSession = session != 'undefined'? JSON.parse(session): undefined;
    const isApiUrl = environment.apiUrl;
    if (useSession && isApiUrl) {
        request =  request.clone({ 
          headers: request.headers
            .set('Authorization', `Bearer ${useSession.access_token}`)
            .set('Content-Type', 'application/json')
       });
    }

    return next.handle(request).pipe(catchError(err => {
      if (err instanceof HttpErrorResponse) {
        switch (err.status) {
          case 401:
            localStorage.removeItem('app_user_session');
            localStorage.removeItem("daily_calender_stats");
            localStorage.removeItem("dashboard_calender_stats");
            this.router.navigate(['/login']);
            break;
          case 403:
            window.alert(`Unable to connect to the server.
            Please refresh the page and retry.`);
            break;
          case 0:
            window.alert(`The system is currently unavailable.  Please try again later.`);
            break;
          default:

            if(request.url.includes('changePassword')){
              break;
            }

            if (err?.error?.Message) window.alert(err.error.Message);
            else if (err?.error?.message) window.alert(err.error.message);
            else if (err?.error) window.alert(err.error);
            else window.alert(`The system is currently unavailable.  Please try again later.`);
            break;
        }
      }
      else{
        return next.handle(request);
      }
      
    })) as Observable<HttpEvent<any>>;
  
}
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];
